@if (showHeader) {
  <p class="title-forms">
    <mat-icon class="module-icon"> departure_board </mat-icon>
    Carrier habilitado
  </p>
}

<mat-form-field class="w-100 black-color">
  <mat-label>{{placeholder}}</mat-label>
  <input
    matInput
    [formControl]="carrier"
    [matAutocomplete]="carrierList"
    (blur)="validateEditCarrier()"
  />
  @if (carrier.value) {
    <button type="button" mat-icon-button matSuffix>
      <mat-icon class="button-clear-filter"
        (click)="cleanCarrier()"
        matTooltip="Borrar"
      >highlight_off</mat-icon>
    </button>
  }
  <mat-autocomplete
    (optionSelected)="changeSelectCarrier()"
    #carrierList="matAutocomplete"
    [displayWith]="displayFnCarrier"
  >
    @for (carrier of listCarrierAutocomplet | async; track carrier) {
      <mat-option [value]="carrier">
        <span> {{ carrier.businessName }} </span>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
